package com.downdogapp.client.views.start

import com.downdogapp.*
import com.downdogapp.AlignItems.CENTER
import com.downdogapp.BoxSizing.BORDER_BOX
import com.downdogapp.Display.FLEX
import com.downdogapp.FlexDirection.ROW
import com.downdogapp.FontWeight.MEDIUM
import com.downdogapp.FontWeight.SEMIBOLD
import com.downdogapp.JustifyContent.SPACE_BETWEEN
import com.downdogapp.Position.RELATIVE
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.Companion.vh
import com.downdogapp.client.*
import com.downdogapp.client.api.SettingSelectorItem
import com.downdogapp.client.controllers.start.NewPracticePage
import com.downdogapp.client.widget.*
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLSpanElement

actual class NewPracticePageView : AbstractView(), View {

  private var titleLabel: HTMLSpanElement
  private val table: TableView
  private val startButton: TextButton

  override val root = createDiv {
    position = RELATIVE
    display = FLEX
    justifyContent = JustifyContent.CENTER

    titleLabel = startPageTitle()

    verticalFlexBox {
      height = vh(100)
      width = px(540)
      paddingTop = StartView.CONTENT_TOP_MARGIN_PX
      paddingBottom = StartView.TITLE_TOP_MARGIN_PX
      boxSizing = BORDER_BOX

      val numRows = SequenceSettings.selectorSections.sumOf { it.items.size + 1 }
      table = tableView(::getContents, maskBottomGradient = numRows > 7)
      startButton = roundedTextButton(
        text = Strings.START,
        marginHorizontal = HORIZONTAL_CONTENT_GUTTER_PX,
        clickFn = ::onStartClicked
      ) {
        marginTop = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
        flexShrink = 0.0
      }
    }
  }

  private fun onStartClicked() {
    NewPracticePage.startPracticeClicked()
    startButton.button.blur() // prevents a bug where pressing spacebar on the loading screen retriggers the button press
  }

  actual fun refreshView() {
    table.refreshContents()
    titleLabel.text = NewPracticePage.title
    startButton.setText(Strings.START)
  }

  private fun getContents() = TableContents(
    rows = SequenceSettings.selectorSections.mapIndexed { index, section ->
      listOf(
        CustomRow.customRow(null) {
          root.apply {
            horizontalFlexBox {
              height = px(if (index == 0) 30 else 50)
              paddingHorizontal = HORIZONTAL_CONTENT_GUTTER_PX
              label(section.title.uppercase(), 14, SEMIBOLD) {
                if (index != 0) {
                  marginTop = px(20)
                }
              }
            }
          }
        }
      ) +
      (0..<SettingsDrawerUtil.numRowsExpanded(section)).map {
        CustomRow.customRow(null) {
          root.apply {
            marginBottom = px(10)
            paddingHorizontal = HORIZONTAL_CONTENT_GUTTER_PX
            display = FLEX
            flexDirection = ROW

            val leftItem = section.items[it * 2]
            val rightItem =
              if (it * 2 + 1 < section.items.size)
                section.items[it * 2 + 1]
              else
                null

            tile(leftItem, true)
            tile(rightItem, false)
          }
        }
      }
    }.flatten()
  )

  private fun HTMLDivElement.tile(item: SettingSelectorItem?, isLeftColumn: Boolean) =
    verticalFlexBox(verticalJustify = SPACE_BETWEEN) {
      flexGrow = 1.0
      flexBasis = px(0)
      height = px(SettingsDrawerUtil.settingTileHeightExpanded(true))
      if (isLeftColumn)
        marginRight = px(SettingsDrawerUtil.settingTileGridMargin / 2)
      else
        marginLeft = px(SettingsDrawerUtil.settingTileGridMargin / 2)

      item?.let {
        bgColor = Color.white(0.15)
        borderRadius = px(8)

        onClick {
          NewPracticePage.selectorClicked(item.typeId)
        }

        horizontalFlexBox(verticalAlign = CENTER) {
          marginTop = px(SettingsDrawerUtil.settingTileVerticalMarginExpanded(true))
          marginHorizontal = px(SettingsDrawerUtil.settingTileHorizontalMargin)

          label(SequenceSettings.getTypeLabel(item.typeId), 14)
        }
        label(SequenceSettings.getSelectedLabel(item.typeId), 16, MEDIUM) {
          marginBottom = px(SettingsDrawerUtil.settingTileVerticalMarginExpanded(true))
          marginHorizontal = px(SettingsDrawerUtil.settingTileHorizontalMargin)
        }
      }
    }

  actual fun updateCircleLabel(hapticFeedback: Boolean) {}
  actual fun updateCircleAngle() {}
  actual fun collapseDrawer() = false
  actual fun expandDrawer(showTooltip: Boolean, onCollapsedDrawer: () -> Unit) {
    onCollapsedDrawer()
  }

  actual fun finishDrawerAnimation() {}
}
